<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">设备管理</a>
          <i>></i>
          <a href="javascript:;">考场管理</a>
          <i>></i>
          <a href="javascript:;">设备列表</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">模块列表</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">新增模块</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-form
              class="ruleForm"
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              size="small"
              label-width="120px"
              ><el-form-item label="模块类型" prop="serialPortDevice">
                <el-select
                  v-model="ruleForm.serialPortDevice"
                  placeholder="请选择"
                  clearable
                  filterable
                  
                  ><el-option
                    v-for="item in serialPortDeviceList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="模块名称" prop="hardwareName">
                <el-input v-model="ruleForm.hardwareName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="模块IP" prop="ipAddress" v-if="['10','81'].includes(ruleForm.serialPortDevice)">
                <el-input v-model="ruleForm.ipAddress" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="有效标签" prop="correct" v-if="['10'].includes(ruleForm.serialPortDevice)">
                <el-input v-model="ruleForm.correct" placeholder="请输入" type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="串口名称" prop="serialPortName" v-if="['21','22'].includes(ruleForm.serialPortDevice)">
                <el-input v-model="ruleForm.serialPortName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="bgc-bv" @click="$router.back()">取消</el-button>
                <el-button type="primary" class="bgc-bv" @click="add_module">确定</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "practicalAssessmentSystem_systemManage_add_room_device_module",
  components: {},
  data() {
    return {
      // 上个页面传过来的数据
      lastPageData: {
        roomId: "",
        codeId: "",
      },
      // 表单数据
      ruleForm: {
        serialPortDevice: "", // 模块类型
        hardwareName:"", // 模块名称
        ipAddress:"", // 模块IP
        correct:"", // 有效标签
        serialPortName:"", // 串口名称
      },
      // 表单数据 - 校验
      rules: {
        serialPortDevice: [
          { required: true, message: '请选择模块类型', trigger: 'change' }
        ],
        hardwareName: [
          { required: true, message: '请输入模块名称', trigger: 'blur' },
        ],
        ipAddress: [
          { required: true, message: '请输入模块IP', trigger: 'blur' },
        ],
        correct: [
          { required: true, message: '请输入有效标签', trigger: 'blur' },
        ],
        serialPortName: [
          { required: true, message: '请输入串口名称', trigger: 'blur' },
        ],
      },
      // 模块类型 - 下拉数据
      serialPortDeviceList: [],
    };
  },
  created() {
    this.lastPageData.roomId = this.$route.query.roomId;
    this.lastPageData.codeId = this.$route.query.codeId;
    this.getInvoice_type();
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    // 获取字典
    getInvoice_type() {
      // 模块类型
      const serialPortDeviceList = this.$setDictionary(
        "PA_AIO_BINDING_DEVICE",
        "list"
      );
      for (const key in serialPortDeviceList) {
        this.serialPortDeviceList.push({
          value: key,
          label: serialPortDeviceList[key],
        });
      }
    },
    // 确定
    add_module() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let cData = {
            ...this.lastPageData,
            serialPortDevice: this.ruleForm.serialPortDevice,
            hardwareName: this.ruleForm.hardwareName
          }
          if(this.ruleForm.ipAddress){
            cData.ipAddress = this.ruleForm.ipAddress;
          }
          if (this.ruleForm.correct) {
            cData.correct = this.ruleForm.correct;
          }
          if (this.ruleForm.serialPortName) {
            cData.serialPortName = this.ruleForm.serialPortName;
          }
          this.$post("/biz/v2/room/device/module/add", cData, 3000, true, 10).then((res) => {
            this.$router.back();
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.ruleForm {
  width: 500px;
}
</style>
